import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import SidebarPersonsLoader from 'components/Loaders/SidebarPersonsLoader';
import * as selectors from '../../../selectors';
import styles from '../PatientsList.pcss';
import ActivePatient from './ActivePatient';
const ActivePatientsList = ({ id, patients, styleModifier, onPatientClick })=>{
    const isInProgress = useSelector(selectors.isFetchPatientsInProgress);
    useStyles(styles);
    if (isInProgress) {
        return /*#__PURE__*/ _jsx(SidebarPersonsLoader, {
            itemsNumber: 5
        });
    }
    const mapFilteredCollection = (patient)=>/*#__PURE__*/ _jsx(ActivePatient, {
            id: id,
            patient: patient,
            styleModifier: styleModifier,
            onPatientClick: onPatientClick
        }, patient.id);
    return /*#__PURE__*/ _jsx("ul", {
        id: id,
        className: styles.items,
        children: patients.map(mapFilteredCollection)
    });
};
export default ActivePatientsList;
